<template>
  <div class="container">
    <el-breadcrumb class="hsb-breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item to="/Account">我的账户</el-breadcrumb-item>
      <el-breadcrumb-item to="/Account">账户管理</el-breadcrumb-item>
      <el-breadcrumb-item>更换手机号码</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="wrapper">
      <div class="form">
        <div class="form-item">
          <hInput
            class="el-input"
            type="tel"
            v-model="loginTel"
            placeholder="请输入手机号"/>
        </div>
        <div class="form-item">
          <hInput
            class="el-input"
            type="number"
            v-model="loginSmsCode"
            placeholder="请输入短信验证码"/>
          <hButton
            class="sms-btn"
            type="primary"
            @click="doGetCode"
            :disabled="isGetSmsCodeButtonDisabled || !!inputError"
          >
            <span>{{ isCounting ? count + 's后获取' : '获取验证码'}}</span>
          </hButton>
        </div>
        <div class="error" v-if="inputError">
          <span>{{ inputError }}</span>
        </div>
        <hButton
          class="mb-base login-btn"
          type="primary"
          size="large"
          :disabled="isSubmitLoginDisabled"
          @click="doUpdateTel"
        >
          <span>确认绑定</span>
        </hButton>
      </div>
      <limitCodePopup
        v-model="limitCodePopupVisible"
        :codeImgSrc="codeImgUrl"
        @on-close="onLimitCodePopupClose"
        @on-confirm="onLimitCodePopupConfirm"
        @on-img-click="showLimitCodePopup"
      ></limitCodePopup>
    </div>
  </div>
</template>

<script type="text/javascript">
// import { Toast, MessageBox } from 'mint-ui';
import checkBox from '@/components/checkbox';
import hButton from '@/components/button';
import hInput from '@/components/input';
import Spinner from '@/components/spinner';
import { mapState } from 'vuex';
import hsbLogin from '@/core/login/hsbLogin';
import { Breadcrumb, BreadcrumbItem } from 'element-ui';

export default {
  mixins: [hsbLogin],
  data () {
    return {
      submitting: false,
      showMerge: false
    };
  },
  components: {
    Spinner,
    checkBox,
    hButton,
    hInput,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem
  },
  props: {
    bindType: {
      type: String,
      default: 'bind' // or update
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo,
      formRule: state => state.config.formRule
    }),
    isUpdateType () {
      return this.bindType === 'update';
    },
    redirect () {
      return this.$route.query.redirect;
    },
    isValidTel () {
      return this.formRule.tel.rule.test(this.tel);
    },
    inputError () {
      let str = '';
      if (this.loginTel === this.userInfo.tel) {
        str = '新手机号和旧手机号不能一样';
      }
      return str;
    },
    formatTel () {
      if (!this.userInfo.tel) {
        return '';
      } else {
        const strList = this.userInfo.tel.split('');
        return strList.map((item, index) => (index > 2 && index < 7) ? '*' : item).join('');
      }
    }
  }
};
</script>

<style type="text/css" scoped>
.wrapper {
  overflow: hidden;
  width: 100%;
  min-height: 420px;
  background-color: #fff;
  /deep/ input,
  /deep/ .hsb-button {
    height: 54px;
  }
  .sms-btn[disabled],
  .hsb-button.is-disabled,
  .hsb-button[disabled] {
    color: #C9CED1;
    background: #E7ECEE;
  }
  .sms-btn {
    background-color: #fff;
    outline: none;
    border: 0;
    color: #3782FF;
    text-align: center;
    &.is-disabled {
      background-color: #fff;
    }
  }
}

/deep/ .mint-toast.is-placemiddle {
  z-index: 20002 !important;
}

.form {
  width: 400px;
  margin: 0 auto;
  margin-top: 80px;
}

.form-item {
  display: flex;
  margin: 0 auto;
  margin-bottom: 20px;
  /deep/ input {
    padding-left: 10px;
    border: none;
    border-radius: 0;
    border: 1px #E9EBED solid;
    border-radius: 4px;
  }
  .el-input {
    flex: 1;
  }
}

.login-btn {
  height: 44px;
  margin-top: 30px;
  font-size: 16px;
  background: #FFDA05;
}

.bind-tip {
  text-align: center;
}

.has-bind .column-logo {
  padding-top: 48px;
}

.already-bind {
  padding-left: 12px;
  padding-right: 12px;
  text-align: center;
  .tip {
    margin-top: 36px;
    color: #646B70;
    font-size: 14px;
    line-height: 20px;
  }
  .tel {
    margin-top: 12px;
    font-size: 22px;
    line-height: 30px;
    color: #2B2D2E;
    font-weight: bold;
  }
  /deep/ .hsb-button--large {
    height: 44px;
    margin-top: 60px;
    font-size: 16px;
    color: #2B2D2E;
  }
}

.error {
  display: flex;
  align-items: center;
  margin-top: 10px;
  line-height: 24px;
  font-size: 13px;
  color: #FF3405;
  img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/account/updateTel.vue